interface AvatarProps {
  nick: string;
  size?: number;
  background?: string;
}

const COLORS = ['#f4b93a', '#8ab4f8', '#f28b82', '#81c995', '#c58af9', '#fcad6f', '#78d9d9', '#eabffd'];

function colorForNick(nick: string): string {
  let hash = 0;
  for (let i = 0; i < nick.length; i++) hash = (hash * 31 + nick.charCodeAt(i)) >>> 0;
  return COLORS[hash % COLORS.length];
}

function initials(nick: string): string {
  if (!nick) return '?';
  const parts = nick.split(/[\s_.-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return nick.slice(0, 2).toUpperCase();
}

export function Avatar({ nick, size = 32, background }: AvatarProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: background ?? colorForNick(nick),
        color: '#0f1e3d',
        fontWeight: 700,
        fontSize: Math.round(size * 0.4),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'inset 0 0 0 0.5px rgba(15,30,61,.15)',
        flexShrink: 0,
      }}
    >
      {initials(nick)}
    </div>
  );
}
